// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskRecordsPage-root {
  min-height: calc(100vh - 60px);
  width: calc(100% - 88px);
  margin-left: 88px;
  color: var(--canvas-ink, #171a17);
  background: var(--canvas-paper, #f3f5f6);
}

.TaskRecordsPage-content {
  width: min(1160px, 100%);
  margin: 0 auto;
  padding: 28px 24px 80px;
}

.TaskRecordsPage-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}

.TaskRecordsPage-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.TaskRecordsPage-filters button {
  min-width: 64px;
  padding: 8px 13px;
  color: #6b736d;
  background: #fff;
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 999px;
  font-size: 11px;
}

.TaskRecordsPage-filters button:hover,
.TaskRecordsPage-filters button.is-active {
  color: var(--canvas-ink, #171a17);
  background: var(--canvas-green-soft, #e3f3cb);
  border-color: var(--canvas-green, #b9df8a);
}

.TaskRecordsPage-sync {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  color: var(--canvas-muted, #737b75);
  font-size: 10px;
}

.TaskRecordsPage-sync i {
  width: 6px;
  height: 6px;
  background: var(--canvas-green-strong, #70a33d);
  border-radius: 50%;
}

.TaskRecordsPage-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.TaskRecordsPage-card {
  min-width: 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 13px;
  box-shadow: 0 10px 30px rgba(24, 30, 26, 0.035);
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.TaskRecordsPage-card:hover {
  border-color: var(--canvas-line-strong, #ccd2ce);
  box-shadow: 0 14px 36px rgba(24, 30, 26, 0.075);
  transform: translateY(-2px);
}

.TaskRecordsPage-card-header {
  display: flex;
  min-height: 65px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 13px 13px 11px;
}

.TaskRecordsPage-card-header > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
}

.TaskRecordsPage-card-header strong {
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskRecordsPage-card-header > div > span {
  overflow: hidden;
  color: var(--canvas-muted, #737b75);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskRecordsPage-status {
  display: inline-flex;
  height: 21px;
  flex: 0 0 auto;
  align-items: center;
  gap: 5px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 8px;
  font-weight: 650;
}

.TaskRecordsPage-status i {
  width: 5px;
  height: 5px;
  background: currentColor;
  border-radius: 50%;
}

.TaskRecordsPage-status.is-completed {
  color: #4f802e;
  background: #e4f3d6;
}

.TaskRecordsPage-status.is-processing {
  color: #9b6b21;
  background: #f8efd9;
}

.TaskRecordsPage-status.is-failed {
  color: #b64d49;
  background: #fae7e5;
}

.TaskRecordsPage-media {
  display: grid;
  width: calc(100% - 20px);
  height: 190px;
  margin: 0 10px;
  place-items: center;
  overflow: hidden;
  background: #e9eeeb;
  border-radius: 9px;
}

.TaskRecordsPage-media-button {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  cursor: zoom-in;
  background: transparent;
  border: 0;
}

.TaskRecordsPage-media-button:focus-visible {
  outline: 2px solid var(--canvas-green-strong, #70a33d);
  outline-offset: -3px;
}

.TaskRecordsPage-media-placeholder-button {
  display: grid;
  place-items: center;
  cursor: pointer;
}

.TaskRecordsPage-media-placeholder-button .TaskRecordsPage-media-open {
  opacity: 1;
  transform: none;
}

.TaskRecordsPage-media-video {
  position: relative;
  width: 100%;
  height: 100%;
}

.TaskRecordsPage-media-video .TaskRecordsPage-media-open {
  top: 10px;
  bottom: auto;
}

.TaskRecordsPage-media-open {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  color: #fff;
  background: rgba(23, 26, 23, 0.74);
  border: 0;
  border-radius: 8px;
  padding: 0;
  cursor: zoom-in;
  font: inherit;
  opacity: 0;
  transform: translateY(3px);
  transition: opacity 160ms ease, transform 160ms ease;
}

.TaskRecordsPage-media-button:hover .TaskRecordsPage-media-open,
.TaskRecordsPage-media-button:focus-visible .TaskRecordsPage-media-open,
.TaskRecordsPage-media-video:hover .TaskRecordsPage-media-open,
.TaskRecordsPage-media-video:focus-within .TaskRecordsPage-media-open {
  opacity: 1;
  transform: translateY(0);
}

.TaskRecordsPage-media img,
.TaskRecordsPage-media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.TaskRecordsPage-media.is-empty {
  background-image: radial-gradient(circle, rgba(86, 102, 91, 0.18) 0.7px, transparent 0.8px);
  background-size: 14px 14px;
}

.TaskRecordsPage-media-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #8a938d;
}

.TaskRecordsPage-media-placeholder span,
.TaskRecordsPage-empty-mark {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border-radius: 12px;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 11px;
  font-weight: 700;
}

.TaskRecordsPage-media-placeholder small {
  font-size: 9px;
}

.TaskRecordsPage-audio {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px;
}

.TaskRecordsPage-audio > span {
  display: grid;
  width: 46px;
  height: 46px;
  place-items: center;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border-radius: 50%;
  font-size: 22px;
}

.TaskRecordsPage-audio audio {
  width: 100%;
  height: 34px;
}

.TaskRecordsPage-prompt {
  min-height: 45px;
  margin: 9px 10px 0;
  padding: 10px;
  overflow: hidden;
  color: #5f675f;
  background: var(--canvas-surface-soft, #f7f8f8);
  border-radius: 8px;
  font-size: 10px;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskRecordsPage-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px;
}

.TaskRecordsPage-card-footer > strong {
  color: var(--canvas-green-strong, #70a33d);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 12px;
}

.TaskRecordsPage-card-footer small {
  font-family: inherit;
  font-size: 8px;
}

.TaskRecordsPage-card-footer time {
  color: var(--canvas-muted, #737b75);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 8px;
}

.TaskRecordsPage-state {
  display: flex;
  min-height: 300px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: var(--canvas-muted, #737b75);
  background: #fff;
  border: 1px dashed var(--canvas-line-strong, #ccd2ce);
  border-radius: 14px;
  font-size: 11px;
}

.TaskRecordsPage-state strong {
  color: var(--canvas-ink, #171a17);
  font-size: 14px;
}

.TaskRecordsPage-state button,
.TaskRecordsPage-pagination button {
  margin-top: 8px;
  padding: 9px 16px;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border: 1px solid var(--canvas-ink, #171a17);
  border-radius: 9px;
  font-size: 11px;
}

.TaskRecordsPage-spinner {
  width: 24px;
  height: 24px;
  margin-bottom: 5px;
  border: 2px solid var(--canvas-line, #e2e6e4);
  border-top-color: var(--canvas-green-strong, #70a33d);
  border-radius: 50%;
  animation: TaskRecordsPage-spin 700ms linear infinite;
}

@keyframes TaskRecordsPage-spin {
  to { transform: rotate(360deg); }
}

.TaskRecordsPage-pagination {
  display: flex;
  min-height: 74px;
  align-items: center;
  justify-content: center;
  color: var(--canvas-muted, #737b75);
  font-size: 10px;
}

.TaskRecordsPage-pagination button:disabled {
  cursor: wait;
  opacity: 0.6;
}

.TaskRecordsPage-modal-backdrop {
  position: fixed;
  z-index: 1400;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(23, 26, 23, 0.42);
  animation: TaskRecordsPage-modal-fade 160ms ease-out;
}

.TaskRecordsPage-modal {
  width: min(760px, 100%);
  max-height: calc(100vh - 48px);
  overflow: auto;
  background: #fff;
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(24, 30, 26, 0.2);
  animation: TaskRecordsPage-modal-rise 180ms ease-out;
}

.TaskRecordsPage-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid var(--canvas-line, #e2e6e4);
}

.TaskRecordsPage-modal-header h2 {
  margin: 0;
  color: var(--canvas-ink, #171a17);
  font-size: 18px;
  font-weight: 740;
}

.TaskRecordsPage-modal-header p {
  margin: 5px 0 0;
  color: var(--canvas-muted, #737b75);
  font-size: 11px;
}

.TaskRecordsPage-modal-close {
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  place-items: center;
  color: var(--canvas-muted, #737b75);
  background: var(--canvas-surface-soft, #f7f8f8);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 8px;
  font-size: 12px;
}

.TaskRecordsPage-modal-close:hover {
  color: var(--canvas-ink, #171a17);
  border-color: var(--canvas-line-strong, #ccd2ce);
}

.TaskRecordsPage-modal-close:focus-visible {
  outline: 2px solid var(--canvas-green-strong, #70a33d);
  outline-offset: 2px;
}

.TaskRecordsPage-modal-body {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(240px, 0.9fr);
  gap: 22px;
  padding: 22px;
}

.TaskRecordsPage-modal-preview {
  display: grid;
  min-height: 300px;
  place-items: center;
  overflow: hidden;
  background: #eef2ef;
  border-radius: 10px;
}

.TaskRecordsPage-modal-preview > img,
.TaskRecordsPage-modal-preview > video {
  display: block;
  width: 100%;
  max-height: 420px;
  object-fit: contain;
}

.TaskRecordsPage-modal-preview > audio {
  width: calc(100% - 36px);
}

.TaskRecordsPage-modal-preview.is-empty {
  background-image: radial-gradient(circle, rgba(86, 102, 91, 0.18) 0.7px, transparent 0.8px);
  background-size: 14px 14px;
}

.TaskRecordsPage-modal-preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 9px;
  color: var(--canvas-muted, #737b75);
  font-size: 11px;
}

.TaskRecordsPage-modal-preview-empty i {
  color: var(--canvas-green-strong, #70a33d);
  font-size: 25px;
}

.TaskRecordsPage-modal-info {
  min-width: 0;
}

.TaskRecordsPage-modal-facts {
  display: grid;
  gap: 0;
  margin: 0;
}

.TaskRecordsPage-modal-facts > div {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr);
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #edf0ee;
}

.TaskRecordsPage-modal-facts dt {
  color: var(--canvas-muted, #737b75);
  font-size: 10px;
}

.TaskRecordsPage-modal-facts dd {
  min-width: 0;
  margin: 0;
  color: var(--canvas-ink, #171a17);
  font-size: 10px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.TaskRecordsPage-modal-facts .TaskRecordsPage-status {
  width: fit-content;
}

.TaskRecordsPage-modal-task-id {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  color: #59675c;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 9px;
}

.TaskRecordsPage-modal-task-id-value {
  min-width: 0;
  overflow-wrap: anywhere;
}

.TaskRecordsPage-copy-id {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  gap: 5px;
  flex: 0 0 auto;
  padding: 4px 8px;
  color: var(--canvas-muted, #737b75);
  background: var(--canvas-surface-soft, #f7f8f8);
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 7px;
  cursor: pointer;
  font-family: inherit;
  font-size: 9px;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.TaskRecordsPage-copy-id:hover {
  color: var(--canvas-ink, #171a17);
  background: #fff;
  border-color: var(--canvas-line-strong, #ccd2ce);
}

.TaskRecordsPage-copy-id:focus-visible {
  outline: 2px solid var(--canvas-green-strong, #70a33d);
  outline-offset: 2px;
}

.TaskRecordsPage-copy-id.is-copied {
  color: #4f802e;
  background: #e4f3d6;
  border-color: #c3e1a4;
}

.TaskRecordsPage-copy-id.is-error {
  color: #b64d49;
  background: #fae7e5;
  border-color: #e9b7b3;
}

.TaskRecordsPage-modal-prompt {
  margin-top: 18px;
}

.TaskRecordsPage-modal-prompt > span {
  color: var(--canvas-muted, #737b75);
  font-size: 10px;
}

.TaskRecordsPage-modal-prompt p {
  max-height: 126px;
  margin: 7px 0 0;
  padding: 10px;
  overflow: auto;
  color: #5f675f;
  background: var(--canvas-surface-soft, #f7f8f8);
  border-radius: 8px;
  font-size: 10px;
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.TaskRecordsPage-modal-result-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
  color: var(--canvas-green-strong, #70a33d);
  font-size: 10px;
  font-weight: 700;
  text-decoration: none;
}

.TaskRecordsPage-modal-result-link:hover {
  color: var(--canvas-ink, #171a17);
}

@keyframes TaskRecordsPage-modal-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes TaskRecordsPage-modal-rise {
  from { opacity: 0; transform: translateY(7px) scale(0.99); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@media (max-width: 900px) {
  .TaskRecordsPage-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 768px) {
  .TaskRecordsPage-root {
    width: calc(100% - 76px);
    margin-left: 76px;
  }
}

@media (max-width: 720px) {
  .TaskRecordsPage-root {
    width: calc(100% - 68px);
    margin-left: 68px;
  }
}

@media (max-width: 620px) {
  .TaskRecordsPage-content { padding: 20px 14px 60px; }
  .TaskRecordsPage-toolbar { align-items: flex-start; flex-direction: column; gap: 12px; }
  .TaskRecordsPage-sync { display: none; }
  .TaskRecordsPage-grid { grid-template-columns: 1fr; }
  .TaskRecordsPage-media { height: 210px; }
}

@media (max-width: 720px) {
  .TaskRecordsPage-modal-body { grid-template-columns: 1fr; }
  .TaskRecordsPage-modal-preview { min-height: 240px; }
}

@media (max-width: 620px) {
  .TaskRecordsPage-modal-backdrop { padding: 12px; }
  .TaskRecordsPage-modal { max-height: calc(100vh - 24px); }
  .TaskRecordsPage-modal-header,
  .TaskRecordsPage-modal-body { padding: 16px; }
}

@media (prefers-reduced-motion: reduce) {
  .TaskRecordsPage-card { transition: none; }
  .TaskRecordsPage-card:hover { transform: none; }
  .TaskRecordsPage-spinner { animation: none; }
  .TaskRecordsPage-media-open,
  .TaskRecordsPage-copy-id,
  .TaskRecordsPage-modal-backdrop,
  .TaskRecordsPage-modal { transition: none; animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/taskRecords/TaskRecordsPage.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iBAAiB;EACjB,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,6CAA6C;EAC7C,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;EACnB,+CAA+C;EAC/C,gFAAgF;AAClF;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,kDAAkD;EAClD,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,sDAAsD;EACtD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,aAAa;EACb,UAAU;EACV,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;;;;EAIE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2FAA2F;EAC3F,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,kDAAkD;EAClD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;EAChB,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,qDAAqD;EACrD,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;EACnB,6CAA6C;EAC7C,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mCAAmC;EACnC,+CAA+C;EAC/C,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2FAA2F;EAC3F,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,MAAM;EACN,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,cAAc;EACd,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,+CAA+C;EAC/C,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,4EAA4E;AAC9E;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,cAAc;EACd,cAAc;EACd,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,wBAAwB,gDAAgD,EAAE;AAC5E;;AAEA;EACE;IACE,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE,2BAA2B,uBAAuB,EAAE;EACpD,2BAA2B,uBAAuB,EAAE,sBAAsB,EAAE,SAAS,EAAE;EACvF,wBAAwB,aAAa,EAAE;EACvC,wBAAwB,0BAA0B,EAAE;EACpD,yBAAyB,aAAa,EAAE;AAC1C;;AAEA;EACE,8BAA8B,0BAA0B,EAAE;EAC1D,iCAAiC,iBAAiB,EAAE;AACtD;;AAEA;EACE,kCAAkC,aAAa,EAAE;EACjD,yBAAyB,8BAA8B,EAAE;EACzD;gCAC8B,aAAa,EAAE;AAC/C;;AAEA;EACE,wBAAwB,gBAAgB,EAAE;EAC1C,8BAA8B,eAAe,EAAE;EAC/C,2BAA2B,eAAe,EAAE;EAC5C;;;2BAGyB,gBAAgB,EAAE,eAAe,EAAE;AAC9D","sourcesContent":[".TaskRecordsPage-root {\n  min-height: calc(100vh - 60px);\n  width: calc(100% - 88px);\n  margin-left: 88px;\n  color: var(--canvas-ink, #171a17);\n  background: var(--canvas-paper, #f3f5f6);\n}\n\n.TaskRecordsPage-content {\n  width: min(1160px, 100%);\n  margin: 0 auto;\n  padding: 28px 24px 80px;\n}\n\n.TaskRecordsPage-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 22px;\n}\n\n.TaskRecordsPage-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.TaskRecordsPage-filters button {\n  min-width: 64px;\n  padding: 8px 13px;\n  color: #6b736d;\n  background: #fff;\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 999px;\n  font-size: 11px;\n}\n\n.TaskRecordsPage-filters button:hover,\n.TaskRecordsPage-filters button.is-active {\n  color: var(--canvas-ink, #171a17);\n  background: var(--canvas-green-soft, #e3f3cb);\n  border-color: var(--canvas-green, #b9df8a);\n}\n\n.TaskRecordsPage-sync {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 7px;\n  color: var(--canvas-muted, #737b75);\n  font-size: 10px;\n}\n\n.TaskRecordsPage-sync i {\n  width: 6px;\n  height: 6px;\n  background: var(--canvas-green-strong, #70a33d);\n  border-radius: 50%;\n}\n\n.TaskRecordsPage-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.TaskRecordsPage-card {\n  min-width: 0;\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 13px;\n  box-shadow: 0 10px 30px rgba(24, 30, 26, 0.035);\n  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.TaskRecordsPage-card:hover {\n  border-color: var(--canvas-line-strong, #ccd2ce);\n  box-shadow: 0 14px 36px rgba(24, 30, 26, 0.075);\n  transform: translateY(-2px);\n}\n\n.TaskRecordsPage-card-header {\n  display: flex;\n  min-height: 65px;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 13px 13px 11px;\n}\n\n.TaskRecordsPage-card-header > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.TaskRecordsPage-card-header strong {\n  overflow: hidden;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.TaskRecordsPage-card-header > div > span {\n  overflow: hidden;\n  color: var(--canvas-muted, #737b75);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 8px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.TaskRecordsPage-status {\n  display: inline-flex;\n  height: 21px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 5px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 8px;\n  font-weight: 650;\n}\n\n.TaskRecordsPage-status i {\n  width: 5px;\n  height: 5px;\n  background: currentColor;\n  border-radius: 50%;\n}\n\n.TaskRecordsPage-status.is-completed {\n  color: #4f802e;\n  background: #e4f3d6;\n}\n\n.TaskRecordsPage-status.is-processing {\n  color: #9b6b21;\n  background: #f8efd9;\n}\n\n.TaskRecordsPage-status.is-failed {\n  color: #b64d49;\n  background: #fae7e5;\n}\n\n.TaskRecordsPage-media {\n  display: grid;\n  width: calc(100% - 20px);\n  height: 190px;\n  margin: 0 10px;\n  place-items: center;\n  overflow: hidden;\n  background: #e9eeeb;\n  border-radius: 9px;\n}\n\n.TaskRecordsPage-media-button {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  overflow: hidden;\n  cursor: zoom-in;\n  background: transparent;\n  border: 0;\n}\n\n.TaskRecordsPage-media-button:focus-visible {\n  outline: 2px solid var(--canvas-green-strong, #70a33d);\n  outline-offset: -3px;\n}\n\n.TaskRecordsPage-media-placeholder-button {\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n}\n\n.TaskRecordsPage-media-placeholder-button .TaskRecordsPage-media-open {\n  opacity: 1;\n  transform: none;\n}\n\n.TaskRecordsPage-media-video {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.TaskRecordsPage-media-video .TaskRecordsPage-media-open {\n  top: 10px;\n  bottom: auto;\n}\n\n.TaskRecordsPage-media-open {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  display: grid;\n  width: 30px;\n  height: 30px;\n  place-items: center;\n  color: #fff;\n  background: rgba(23, 26, 23, 0.74);\n  border: 0;\n  border-radius: 8px;\n  padding: 0;\n  cursor: zoom-in;\n  font: inherit;\n  opacity: 0;\n  transform: translateY(3px);\n  transition: opacity 160ms ease, transform 160ms ease;\n}\n\n.TaskRecordsPage-media-button:hover .TaskRecordsPage-media-open,\n.TaskRecordsPage-media-button:focus-visible .TaskRecordsPage-media-open,\n.TaskRecordsPage-media-video:hover .TaskRecordsPage-media-open,\n.TaskRecordsPage-media-video:focus-within .TaskRecordsPage-media-open {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.TaskRecordsPage-media img,\n.TaskRecordsPage-media video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.TaskRecordsPage-media.is-empty {\n  background-image: radial-gradient(circle, rgba(86, 102, 91, 0.18) 0.7px, transparent 0.8px);\n  background-size: 14px 14px;\n}\n\n.TaskRecordsPage-media-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: #8a938d;\n}\n\n.TaskRecordsPage-media-placeholder span,\n.TaskRecordsPage-empty-mark {\n  display: grid;\n  width: 42px;\n  height: 42px;\n  place-items: center;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border-radius: 12px;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.TaskRecordsPage-media-placeholder small {\n  font-size: 9px;\n}\n\n.TaskRecordsPage-audio {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 20px;\n}\n\n.TaskRecordsPage-audio > span {\n  display: grid;\n  width: 46px;\n  height: 46px;\n  place-items: center;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border-radius: 50%;\n  font-size: 22px;\n}\n\n.TaskRecordsPage-audio audio {\n  width: 100%;\n  height: 34px;\n}\n\n.TaskRecordsPage-prompt {\n  min-height: 45px;\n  margin: 9px 10px 0;\n  padding: 10px;\n  overflow: hidden;\n  color: #5f675f;\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border-radius: 8px;\n  font-size: 10px;\n  line-height: 1.5;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.TaskRecordsPage-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 13px;\n}\n\n.TaskRecordsPage-card-footer > strong {\n  color: var(--canvas-green-strong, #70a33d);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 12px;\n}\n\n.TaskRecordsPage-card-footer small {\n  font-family: inherit;\n  font-size: 8px;\n}\n\n.TaskRecordsPage-card-footer time {\n  color: var(--canvas-muted, #737b75);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 8px;\n}\n\n.TaskRecordsPage-state {\n  display: flex;\n  min-height: 300px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  color: var(--canvas-muted, #737b75);\n  background: #fff;\n  border: 1px dashed var(--canvas-line-strong, #ccd2ce);\n  border-radius: 14px;\n  font-size: 11px;\n}\n\n.TaskRecordsPage-state strong {\n  color: var(--canvas-ink, #171a17);\n  font-size: 14px;\n}\n\n.TaskRecordsPage-state button,\n.TaskRecordsPage-pagination button {\n  margin-top: 8px;\n  padding: 9px 16px;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border: 1px solid var(--canvas-ink, #171a17);\n  border-radius: 9px;\n  font-size: 11px;\n}\n\n.TaskRecordsPage-spinner {\n  width: 24px;\n  height: 24px;\n  margin-bottom: 5px;\n  border: 2px solid var(--canvas-line, #e2e6e4);\n  border-top-color: var(--canvas-green-strong, #70a33d);\n  border-radius: 50%;\n  animation: TaskRecordsPage-spin 700ms linear infinite;\n}\n\n@keyframes TaskRecordsPage-spin {\n  to { transform: rotate(360deg); }\n}\n\n.TaskRecordsPage-pagination {\n  display: flex;\n  min-height: 74px;\n  align-items: center;\n  justify-content: center;\n  color: var(--canvas-muted, #737b75);\n  font-size: 10px;\n}\n\n.TaskRecordsPage-pagination button:disabled {\n  cursor: wait;\n  opacity: 0.6;\n}\n\n.TaskRecordsPage-modal-backdrop {\n  position: fixed;\n  z-index: 1400;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  background: rgba(23, 26, 23, 0.42);\n  animation: TaskRecordsPage-modal-fade 160ms ease-out;\n}\n\n.TaskRecordsPage-modal {\n  width: min(760px, 100%);\n  max-height: calc(100vh - 48px);\n  overflow: auto;\n  background: #fff;\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 14px;\n  box-shadow: 0 24px 70px rgba(24, 30, 26, 0.2);\n  animation: TaskRecordsPage-modal-rise 180ms ease-out;\n}\n\n.TaskRecordsPage-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 20px 22px 16px;\n  border-bottom: 1px solid var(--canvas-line, #e2e6e4);\n}\n\n.TaskRecordsPage-modal-header h2 {\n  margin: 0;\n  color: var(--canvas-ink, #171a17);\n  font-size: 18px;\n  font-weight: 740;\n}\n\n.TaskRecordsPage-modal-header p {\n  margin: 5px 0 0;\n  color: var(--canvas-muted, #737b75);\n  font-size: 11px;\n}\n\n.TaskRecordsPage-modal-close {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 auto;\n  place-items: center;\n  color: var(--canvas-muted, #737b75);\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 8px;\n  font-size: 12px;\n}\n\n.TaskRecordsPage-modal-close:hover {\n  color: var(--canvas-ink, #171a17);\n  border-color: var(--canvas-line-strong, #ccd2ce);\n}\n\n.TaskRecordsPage-modal-close:focus-visible {\n  outline: 2px solid var(--canvas-green-strong, #70a33d);\n  outline-offset: 2px;\n}\n\n.TaskRecordsPage-modal-body {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(240px, 0.9fr);\n  gap: 22px;\n  padding: 22px;\n}\n\n.TaskRecordsPage-modal-preview {\n  display: grid;\n  min-height: 300px;\n  place-items: center;\n  overflow: hidden;\n  background: #eef2ef;\n  border-radius: 10px;\n}\n\n.TaskRecordsPage-modal-preview > img,\n.TaskRecordsPage-modal-preview > video {\n  display: block;\n  width: 100%;\n  max-height: 420px;\n  object-fit: contain;\n}\n\n.TaskRecordsPage-modal-preview > audio {\n  width: calc(100% - 36px);\n}\n\n.TaskRecordsPage-modal-preview.is-empty {\n  background-image: radial-gradient(circle, rgba(86, 102, 91, 0.18) 0.7px, transparent 0.8px);\n  background-size: 14px 14px;\n}\n\n.TaskRecordsPage-modal-preview-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 9px;\n  color: var(--canvas-muted, #737b75);\n  font-size: 11px;\n}\n\n.TaskRecordsPage-modal-preview-empty i {\n  color: var(--canvas-green-strong, #70a33d);\n  font-size: 25px;\n}\n\n.TaskRecordsPage-modal-info {\n  min-width: 0;\n}\n\n.TaskRecordsPage-modal-facts {\n  display: grid;\n  gap: 0;\n  margin: 0;\n}\n\n.TaskRecordsPage-modal-facts > div {\n  display: grid;\n  grid-template-columns: 68px minmax(0, 1fr);\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid #edf0ee;\n}\n\n.TaskRecordsPage-modal-facts dt {\n  color: var(--canvas-muted, #737b75);\n  font-size: 10px;\n}\n\n.TaskRecordsPage-modal-facts dd {\n  min-width: 0;\n  margin: 0;\n  color: var(--canvas-ink, #171a17);\n  font-size: 10px;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n\n.TaskRecordsPage-modal-facts .TaskRecordsPage-status {\n  width: fit-content;\n}\n\n.TaskRecordsPage-modal-task-id {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  color: #59675c;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 9px;\n}\n\n.TaskRecordsPage-modal-task-id-value {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.TaskRecordsPage-copy-id {\n  display: inline-flex;\n  min-height: 26px;\n  align-items: center;\n  gap: 5px;\n  flex: 0 0 auto;\n  padding: 4px 8px;\n  color: var(--canvas-muted, #737b75);\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 7px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 9px;\n  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;\n}\n\n.TaskRecordsPage-copy-id:hover {\n  color: var(--canvas-ink, #171a17);\n  background: #fff;\n  border-color: var(--canvas-line-strong, #ccd2ce);\n}\n\n.TaskRecordsPage-copy-id:focus-visible {\n  outline: 2px solid var(--canvas-green-strong, #70a33d);\n  outline-offset: 2px;\n}\n\n.TaskRecordsPage-copy-id.is-copied {\n  color: #4f802e;\n  background: #e4f3d6;\n  border-color: #c3e1a4;\n}\n\n.TaskRecordsPage-copy-id.is-error {\n  color: #b64d49;\n  background: #fae7e5;\n  border-color: #e9b7b3;\n}\n\n.TaskRecordsPage-modal-prompt {\n  margin-top: 18px;\n}\n\n.TaskRecordsPage-modal-prompt > span {\n  color: var(--canvas-muted, #737b75);\n  font-size: 10px;\n}\n\n.TaskRecordsPage-modal-prompt p {\n  max-height: 126px;\n  margin: 7px 0 0;\n  padding: 10px;\n  overflow: auto;\n  color: #5f675f;\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border-radius: 8px;\n  font-size: 10px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.TaskRecordsPage-modal-result-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 16px;\n  color: var(--canvas-green-strong, #70a33d);\n  font-size: 10px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.TaskRecordsPage-modal-result-link:hover {\n  color: var(--canvas-ink, #171a17);\n}\n\n@keyframes TaskRecordsPage-modal-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes TaskRecordsPage-modal-rise {\n  from { opacity: 0; transform: translateY(7px) scale(0.99); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@media (max-width: 900px) {\n  .TaskRecordsPage-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n@media (max-width: 768px) {\n  .TaskRecordsPage-root {\n    width: calc(100% - 76px);\n    margin-left: 76px;\n  }\n}\n\n@media (max-width: 720px) {\n  .TaskRecordsPage-root {\n    width: calc(100% - 68px);\n    margin-left: 68px;\n  }\n}\n\n@media (max-width: 620px) {\n  .TaskRecordsPage-content { padding: 20px 14px 60px; }\n  .TaskRecordsPage-toolbar { align-items: flex-start; flex-direction: column; gap: 12px; }\n  .TaskRecordsPage-sync { display: none; }\n  .TaskRecordsPage-grid { grid-template-columns: 1fr; }\n  .TaskRecordsPage-media { height: 210px; }\n}\n\n@media (max-width: 720px) {\n  .TaskRecordsPage-modal-body { grid-template-columns: 1fr; }\n  .TaskRecordsPage-modal-preview { min-height: 240px; }\n}\n\n@media (max-width: 620px) {\n  .TaskRecordsPage-modal-backdrop { padding: 12px; }\n  .TaskRecordsPage-modal { max-height: calc(100vh - 24px); }\n  .TaskRecordsPage-modal-header,\n  .TaskRecordsPage-modal-body { padding: 16px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .TaskRecordsPage-card { transition: none; }\n  .TaskRecordsPage-card:hover { transform: none; }\n  .TaskRecordsPage-spinner { animation: none; }\n  .TaskRecordsPage-media-open,\n  .TaskRecordsPage-copy-id,\n  .TaskRecordsPage-modal-backdrop,\n  .TaskRecordsPage-modal { transition: none; animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
